import { ECapability } from '~/features/user/models'

export const CAPABILITY_DISPLAY_LABELS: Record<ECapability, string> = {
  [ECapability.orgConfig]: 'Org configuration',
  [ECapability.userManagement]: 'User management',
  [ECapability.aiAssistantConfig]: 'AI assistant configuration',
  [ECapability.knowledgeBase]: 'Knowledge Base',
  [ECapability.crm]: 'Inbox and contacts',
  [ECapability.reporting]: 'Reporting',
  [ECapability.campaigns]: 'Campaigns',
  [ECapability.voipConfig]: 'VoIP configuration',
  [ECapability.voipVoicemails]: 'VoIP call history',
}

export const VOIP_MANAGE_TEAM_CAPABILITIES: ECapability[] = [
  ECapability.voipConfig,
  ECapability.voipVoicemails,
]

export const USER_CAPABILITY_DISPLAY_ORDER: ECapability[] = [
  ECapability.orgConfig,
  ECapability.userManagement,
  ECapability.aiAssistantConfig,
  ECapability.knowledgeBase,
  ECapability.crm,
  ECapability.reporting,
  ECapability.campaigns,
  ...VOIP_MANAGE_TEAM_CAPABILITIES,
]

/** Capabilities shown on Manage Team when the org does not have the voip feature. */
export function getUserCapabilityDisplayOrder(
  hasVoipOrgFeature: boolean,
): ECapability[] {
  if (hasVoipOrgFeature) {
    return USER_CAPABILITY_DISPLAY_ORDER
  }
  return USER_CAPABILITY_DISPLAY_ORDER.filter(
    (capability) => !VOIP_MANAGE_TEAM_CAPABILITIES.includes(capability),
  )
}

export const MANAGED_PERMISSION_CAPABILITIES = [
  ECapability.orgConfig,
  ECapability.voipConfig,
  ECapability.voipVoicemails,
  ECapability.crm,
  ECapability.campaigns,
  ECapability.aiAssistantConfig,
  ECapability.knowledgeBase,
  ECapability.reporting,
  ECapability.userManagement,
] as const

/** Capabilities included in invite/edit permission payloads for the current org. */
export function getManagedPermissionCapabilities(
  hasVoipOrgFeature: boolean,
): readonly ECapability[] {
  if (hasVoipOrgFeature) {
    return MANAGED_PERMISSION_CAPABILITIES
  }
  return MANAGED_PERMISSION_CAPABILITIES.filter(
    (capability) => !VOIP_MANAGE_TEAM_CAPABILITIES.includes(capability),
  )
}

const TIME_OFFSET_BETWEEN_CREATED_AND_LAST_LOGIN = 5

export default TIME_OFFSET_BETWEEN_CREATED_AND_LAST_LOGIN
